import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';

import {Observable} from 'rxjs';

import {environment} from 'src/environments/environment';
import { Produto, ProdutoLista } from '../interface/produto';
import { UtilService } from './util';

@Injectable({
  providedIn: 'root'
})
export class ProdutoService {
  url = `${environment.urlApiProtheus}/wsrproduto`;

  constructor(
    private httpClient: HttpClient,
    private utilService: UtilService
  ) {
  }

  getProduto(value: string): Observable<Produto> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.httpClient.get<Produto>(`${this.url}/${value}`,httpOptions);
  }

  getProdutoLista(filtro: {}): Observable<ProdutoLista> {
    const httpOptions = this.utilService.filtrosHttpOptions(filtro);
    return this.httpClient.get<ProdutoLista>(`${this.url}`,httpOptions);
  }

}
